import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/firestore'
import 'firebase/storage'
import 'firebase/analytics'

import isEmpty from 'lodash/isEmpty'
import tenants from './tenants.json'
// Static, non-secret Firebase project config. `apiKey` is intentionally not
// included here: it is provided at runtime via appData.config.firebase_api_key
// (set on the server from the FIREBASE_API_KEY env var) and passed to
// getFirebaseApp() at the call site. This avoids baking the key into the
// client bundle and lets the key rotate without a rebuild.
const firebaseConfig = {
  authDomain: 'perfect-transit-180701.firebaseapp.com',
  projectId: 'perfect-transit-180701',
  storageBucket: 'perfect-transit-180701.appspot.com',
  messagingSenderId: '564113948178',
  appId: '1:564113948178:web:29b71c80afe263938222cb',
  measurementId: 'G-BN4SLNMRN3',
}

var firebaseApp = {}

function createMockFirebaseApp() {
  const mockUser = {
    uid: 'mock-user-id',
    email: 'mock@bottlezoo.test',
    emailVerified: true,
    displayName: 'Mock User',
    photoURL: '',
    phoneNumber: null,
    isAnonymous: false,
    providerData: [{ providerId: 'password', uid: 'mock@bottlezoo.test' }],
    getIdToken: async () => 'mock-token',
    getIdTokenResult: async () => ({ token: 'mock-token', claims: {}, expirationTime: '', authTime: '', issuedAtTime: '', signInProvider: 'password' }),
    reload: async () => {},
    sendEmailVerification: async () => {},
    updateProfile: async () => {},
    delete: async () => {},
  }
  const mockCredential = { user: mockUser, credential: null, additionalUserInfo: { isNewUser: false } }
  const noop = () => {}
  const mockAuth = {
    tenantId: null,
    currentUser: mockUser,
    onAuthStateChanged: (cb) => { Promise.resolve().then(() => cb(mockUser)); return noop },
    onIdTokenChanged: (cb) => { Promise.resolve().then(() => cb(mockUser)); return noop },
    signInWithEmailAndPassword: async () => mockCredential,
    createUserWithEmailAndPassword: async () => mockCredential,
    signInWithPopup: async () => mockCredential,
    signInWithRedirect: async () => {},
    getRedirectResult: async () => ({ user: null, credential: null }),
    signOut: async () => {},
    sendPasswordResetEmail: async () => {},
    confirmPasswordReset: async () => {},
    verifyPasswordResetCode: async () => 'mock@bottlezoo.test',
    applyActionCode: async () => {},
    checkActionCode: async () => ({ data: { email: 'mock@bottlezoo.test' }, operation: 'PASSWORD_RESET' }),
    setPersistence: async () => {},
    useDeviceLanguage: noop,
  }
  return {
    auth: mockAuth,
    googleProvider: {},
    facebookProvider: {},
    appleProvider: {},
    db: null,
    now: null,
    storage: null,
    analytics: null,
  }
}

function getFirebaseApp(tenant_id, apiKey) {
  if (window) {
    if (process.env.NEXT_PUBLIC_MOCK_AUTH === 'true') {
      if (isEmpty(firebaseApp)) firebaseApp = createMockFirebaseApp()
      firebaseApp.auth.tenantId = tenant_id
      return firebaseApp
    }
    const hostname = window.location.hostname

    if (isEmpty(firebaseApp)) {
      // apiKey comes from appData.config.firebase_api_key (set at request time
      // from the FIREBASE_API_KEY env var) - see connector/utils/createAppData.
      // If it has not arrived yet, return a no-op stub so callers like
      //   getFirebaseApp(...).auth.onAuthStateChanged(cb)
      // do not crash with "Cannot read properties of undefined". The auth
      // listener subscribed in _app/SessionProvider is re-run once the key
      // arrives (deps include config.firebase_api_key).
      if (!apiKey) {
        return {
          auth: {
            tenantId: tenant_id,
            onAuthStateChanged: () => () => {},
            onIdTokenChanged: () => () => {},
            signOut: async () => {},
            setPersistence: async () => {},
          },
          googleProvider: {},
          facebookProvider: {},
          appleProvider: {},
          db: null,
          now: null,
          storage: null,
          analytics: null,
        }
      }
      if (!firebase.apps.length) {
        firebase.initializeApp({ ...firebaseConfig, apiKey })
      }
      const app = firebase.app()
      const auth = firebase.auth()
      const analytics = firebase.analytics()

      const db = firebase.firestore()
      const googleProvider = new firebase.auth.GoogleAuthProvider()
      var appleProvider = new firebase.auth.OAuthProvider('apple.com')
      appleProvider.addScope('email')
      appleProvider.addScope('name')
      const facebookProvider = new firebase.auth.FacebookAuthProvider()
      auth.tenantId = tenant_id
      const now = firebase.firestore.Timestamp.now()
      const storage = firebase.storage()
      firebase.analytics()
      firebase.auth().setPersistence(firebase.auth.Auth.Persistence.LOCAL)
      firebaseApp = {
        auth,
        googleProvider,
        facebookProvider,
        appleProvider,
        db,
        now,
        storage,
        analytics,
      }
    }
  }
  return firebaseApp
}

export { getFirebaseApp }
